import { PropsWithChildren, useEffect, useState } from 'react';

import { getClientModulesState, initializeClientModules } from '@/clientModules';

export default function ClientModulesProvider({ children }: PropsWithChildren) {
  const [modulesReady, setModulesReady] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const modulesState = getClientModulesState();
    if (modulesState === 'initialized') {
      setModulesReady(true);
    } else if (modulesState === 'idle') {
      void initializeClientModules()
        .then(() => {
          setModulesReady(true);
        })
        .catch((err: unknown) => {
          console.error('Failed to initialize client modules:', err);
          setError(err instanceof Error ? err : new Error(String(err)));
        });
    }
  }, []);

  if (error) {
    throw error;
  }

  if (!modulesReady) {
    return null;
  }

  return children;
}
